export { AsApp } from './as-app.ts';
export type { GetMeshEvent } from './as-app.ts';
export { getAppInfo, getAppSettings, getAppConfig, getAppSuiteConfig } from './app-config.ts';
export type { AppSettings, AppConfig, AppSuiteConfig, HubSpotConfig, ParamateDetails } from './app-config.ts';
export { langAbbrev } from './localization.ts';

import { AsApp } from './as-app.ts';

if (!customElements.get('as-app')) {
  customElements.define('as-app', AsApp);
} else {
  console.warn('as-app already defined');
}
